export const Str = {
    empty: '',
    Hash: '#',
};
